export default __webpack_public_path__ + "static/controller-8470950d90a57765df8b9696b450bee3.png";